import { render, staticRenderFns } from "./TenantBillingDetails.vue?vue&type=template&id=004c0967"
import script from "./TenantBillingDetails.vue?vue&type=script&lang=js"
export * from "./TenantBillingDetails.vue?vue&type=script&lang=js"
import style0 from "./TenantBillingDetails.vue?vue&type=style&index=0&id=004c0967&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports